export default (node) => {
  const productClick = node.querySelector('[data-product-click]');
  const isDoubleWidth = node.classList.contains('product-thumb--double-width');

  const onClickProduct = (e) => {
    const {
      productTitle,
      productPrice = 0,
      productId,
    } = e.currentTarget.dataset;

    if (productTitle) {
      dataLayer.push({
        event: 'productClick',
        ecommerce: {
          click: {
            products: [
              {
                name: productTitle, // Name or ID is required.
                id: productId,
                price: productPrice / 100,
              },
            ],
          },
        },
      });
    }
  };

  const setDoubleWidthHeight = () => {
    if (!isDoubleWidth) return;

    // Find the grid container (parent with grid classes)
    const gridContainer = node.closest('.collection-products-thumbs, .grid');
    if (!gridContainer) return;

    // Find a single-width product in the same grid
    const singleWidthProduct = gridContainer.querySelector(
      '.product-thumb:not(.product-thumb--double-width) .product__top'
    );

    if (singleWidthProduct) {
      const singleWidth = singleWidthProduct.clientWidth;

      let singleWidthHeight = singleWidth * 1.33;

      if (singleWidthHeight > 0) {
        node.style.setProperty(
          '--double-width-height',
          `${singleWidthHeight}px`
        );
      }
    }
  };

  const init = () => {
    if (productClick) {
      productClick.addEventListener('click', onClickProduct);
    }

    // Set height for double-width products
    if (isDoubleWidth) {
      setDoubleWidthHeight();

      // Also recalculate on window resize
      const resizeObserver = new ResizeObserver(() => {
        setDoubleWidthHeight();
      });

      resizeObserver.observe(node);
    }
  };

  init();
};
